import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=11c7a0fa"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"
import style0 from "./Archive.vue?vue&type=style&index=0&id=11c7a0fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports